// Module
var code = "<section class=\"sw-page\" ng-class=\"{ 'sw-page--columnar': $ctrl.isColumnar }\" ng-transclude></section> ";
// Exports
export default code;